import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, Avatar } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import ReportIcon from '@material-ui/icons/InsertChart';
import ExpensesIcon from '@material-ui/icons/AttachMoney';
import SettingsIcon from '@material-ui/icons/Settings';

//New Icons
import DashboardIcon from '@material-ui/icons/Home';
import StudentsIcon from '@material-ui/icons/AssignmentInd';
import GenerateLoginIcon from '@material-ui/icons/ImportantDevices';
import UploadIcon from '@material-ui/icons/CloudUpload';
import GalleryIcon from '@material-ui/icons/Collections';
import PromoCodeIcon from '@material-ui/icons/LocalOffer';

// App Classes
// import ManageTask from '../Tasks/ManageTask';

//CSS Module
const styles = (theme) => ({
  container: {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  formControl: {
    margin: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 300,
  },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },

  paper: {
    padding: theme.spacing.unit * 2,
    height: 80,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    justify: 'center',
    fontSize: '14',
  },
});

//Main Class
class Applications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_type: this.props.user_type,
      user: this.props.user,
      spacing: '16',
    };
  }

  profileUI = () => {
    const { classes } = this.props;
    const { user_type } = this.state;

    return (
      <div className={classes.root}>
        <Grid container spacing={12}>
          <Grid item xs={4}>
            <li>
              <Link to={`${process.env.PUBLIC_URL}/students`}>
                <Button className={classes.paper}>
                  <StudentsIcon className={classes.leftIcon} /> Students
                </Button>
              </Link>
            </li>
          </Grid>

          <Grid item xs={4}>
            <li>
              <Link to={`${process.env.PUBLIC_URL}/generate`}>
                <Button className={classes.paper}>
                  <GenerateLoginIcon className={classes.leftIcon} />
                  Generate Login
                </Button>
              </Link>
            </li>
          </Grid>
          <Grid item xs={4}>
            <li>
              <Link to={`${process.env.PUBLIC_URL}/upload`}>
                <Button className={classes.paper} onClick={this.onTapOptions}>
                  <UploadIcon className={classes.leftIcon} />
                  Upload
                </Button>
              </Link>
            </li>
          </Grid>

          {/*}

					<Grid item xs={4}>
						<li>
							<Link to={`${process.env.PUBLIC_URL}/gallery`}>
								<Button className={classes.paper}>
								<GalleryIcon  className={classes.leftIcon}/>
									Gallery
								</Button>
							</Link>
						</li>
					</Grid>
		*/}

          <Grid item xs={4}>
            <li>
              <Link to={`${process.env.PUBLIC_URL}/reports`}>
                <Button className={classes.paper}>
                  <ReportIcon className={classes.leftIcon} />
                  Reports
                </Button>
              </Link>
            </li>
          </Grid>

          {/*}

					<Grid item xs={4}>
						<li>
							<Link to={`${process.env.PUBLIC_URL}/settings`}>
								<Button className={classes.paper}>
									<SettingsIcon  className={classes.leftIcon}/>Settings
								</Button>
							</Link>
						</li>
					</Grid>
	*/}
        </Grid>

        <Switch>
          {/* <Route
						exact
						path="/manage_task"
						render={(props) => <ManageTask onLoadMenu={this.onCollapseMenu} {...props} />}
					/> */}
        </Switch>
      </div>
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Card className={classes.card}>
          <CardContent>
            <Typography>{this.profileUI()}</Typography>
          </CardContent>
        </Card>
      </div>
    );
  }
}

Applications.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Applications);
